<template>
    <Dialog class="semler-dialog"
        @hide="() => { this.$emit('closePopup') }" v-model:visible="showPopup" :dismissableMask="true"
        :draggable="false" modal :showHeader="false" style="width:330px;border-radius: 15px" :pt="{
            root: 'border-none'
        }">
        <template #default="{ closeCallback }">
            <div class="semler-swiper__dialog-wrap semler-swiper__dialog-wrap--save-prompt">
                <img class="semler-swiper__close" src="/assets/images/semlerSwiper/Luk-Swiper_icon_X.svg"
                height="24" width="24" alt="" role="button" @click="handleCloseClick(false)" tabindex="0" />
                <p class="semler-swiper__dialog-headline">{{ dictionary.semlerSwiperSavePromptHeadline }}</p>
                <p class="semler-swiper__dialog-text" v-html="dictionary.semlerSwiperSavePromptText"></p>
                    <div style="display:grid;grid-template-columns:1fr 1fr;column-gap:5px;width:100%;margin-top:15px">
                        <Button class="p-button-primary p-button-sm" style="justify-content: center;" @click="handleUserCreateClick">{{dictionary.semlerSwiperSavePromptCreateUserButtonLabel}}</Button>
                        <Button class="p-button-secondary p-button-sm" style="justify-content: center;" @click="handleUserLoginClick">{{dictionary.semlerSwiperSavePromptLoginButtonLabel}}</Button>

                    </div>
                <Button class="p-button-secondary p-button-sm" style="margin-top:15px" text @click="handleCloseClick(true)">{{dictionary.semlerSwiperSavePromptCloseSwiperButtonLabel}}</Button>

            </div>

        </template>
    </Dialog>
</template>
<script>

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import CustomEventNames from './../../customEventsNames';
const panelToggleSelector = '.member-panel__toggle';

export default {
    name: "swiperSavePrompt",
    props: ["visible","dictionary"],
    components: {
        Button,
        Dialog
    },
    data() {
        return {
            showPopup: false
        };
    },
    mounted() {
        const vm = this;
        document.addEventListener('click', e => {
            if (e.target.classList.contains('user-signup-popup__login-trigger')) {
                vm.handleUserLoginClick();
            }
        })
    },
    watch: {
        visible: function (newValue, oldValue) {
            this.showPopup = newValue;
        }
    },
    methods: {
        handleUserLoginClick: function () {
            this.showPopup = false;
            this.$emit('closePopup');
            const openUserLoginPanelEvent = new Event(CustomEventNames.openUserLoginPanel);
            document.querySelector(panelToggleSelector).dispatchEvent(openUserLoginPanelEvent);
        },
        handleUserCreateClick: function () {
            this.showPopup = false;
            this.$emit('closePopup');
            const panelToggle = document.querySelector(panelToggleSelector);
            panelToggle.click();
            const openUserCreationPanelEvent = new Event(CustomEventNames.openUserCreationPanel);
            panelToggle.dispatchEvent(openUserCreationPanelEvent);
        },
        handleCloseClick: function (closeSwiper) {
            this.showPopup = false;
            this.$emit('closePopup', closeSwiper);
        }
    }
}
</script>
